import { AppContext } from 'state/context'
import { useContextSelector } from 'use-context-selector'

export const useProjectsForCompany = (companyId: number | undefined) => {
  return useContextSelector(AppContext, ([{ projects }]) =>
    projects.filter(project => project.companyId === companyId),
  )
}
